import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { ContextualMenu, } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { lazyChangeSearchScope } from 'owa-mail-search-actions';
import { lazySetShowFiltersMenu, searchStore } from 'owa-mail-search-store';
import { compareSearchScope, getKey } from 'owa-search-service';
import { SEARCH_BOX_SOURCE } from '../utils/searchViewConstants';
import * as React from 'react';
import getSearchScopeDisplayName from 'owa-mail-search/lib/utils/getSearchScopeDisplayName';
var styles = require('./FiltersContextMenu.scss');
var FiltersContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(FiltersContextMenu, _super);
    function FiltersContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismiss = function (evt) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.stopPropagation();
                        return [4 /*yield*/, lazySetShowFiltersMenu.importAndExecute(false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Handle change in folder scope from the filter context menu
         */
        _this.changeFolderScope = function (evt, newFolderId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // set the new folder scope
                    return [4 /*yield*/, lazyChangeSearchScope(newFolderId)];
                    case 1:
                        // set the new folder scope
                        _a.sent();
                        this.props.onFolderScopeChanged();
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    FiltersContextMenu.prototype.render = function () {
        return (React.createElement(ContextualMenu, { shouldFocusOnMount: true, target: this.props.targetElement, className: styles.filtersContextMenu, directionalHintFixed: true, gapSpace: 2, onDismiss: this.onDismiss, directionalHint: 6 /* bottomRightEdge */, items: this.searchMenuItems }));
    };
    Object.defineProperty(FiltersContextMenu.prototype, "searchMenuItems", {
        get: function () {
            var _this = this;
            var currentSearchScope = searchStore.staticSearchScope;
            var searchScopes = searchStore.staticSearchScopeList.slice();
            // Add the current folder scope (if not there already).
            var searchResultArray = searchScopes.filter(function (searchScope) {
                return compareSearchScope(searchScope, currentSearchScope);
            });
            if (searchResultArray.length <= 0) {
                searchScopes.push(currentSearchScope);
            }
            // Create the filter context menus
            var items = [];
            var _loop_1 = function (i) {
                var searchScope = searchScopes[i];
                var displayName = getSearchScopeDisplayName(searchScope);
                items.push({
                    key: getKey(searchScope),
                    name: displayName,
                    canCheck: true,
                    isChecked: compareSearchScope(searchScope, searchStore.staticSearchScope),
                    onRender: function () { return (React.createElement("div", { "data-is-focusable": true, className: styles.filterMenuItem, "data-click-source": SEARCH_BOX_SOURCE, onClick: function (evt) { return _this.changeFolderScope(evt, searchScope); } },
                        React.createElement("div", { className: styles.checkMarkContainer }, compareSearchScope(searchScope, searchStore.staticSearchScope) && (React.createElement(Icon, { iconName: "CheckMark" /* CheckMark */ }))),
                        React.createElement("div", { className: styles.folderName }, displayName))); },
                });
            };
            for (var i = 0; i < searchScopes.length; i++) {
                _loop_1(i);
            }
            return items;
        },
        enumerable: true,
        configurable: true
    });
    FiltersContextMenu = tslib_1.__decorate([
        observer
    ], FiltersContextMenu);
    return FiltersContextMenu;
}(React.Component));
export default FiltersContextMenu;
//# sourceMappingURL=FiltersContextMenu.js.map